<!-- <script>window.dispatchEvent(init)</script> -->
<button id="wizualizacja" mat-flat-button class="mmaterial-symbols-outlined" color="primary" style="margin-top: 2em" type="button" (click)="openVisualizationDialog()">{{'wizualizacja' | translate}} <mat-icon class="ml-1">search</mat-icon></button>
